// components/Unauthorized.js
const Unauthorized = () => {
  return (
    <div className="text-center mt-5">
      <h2>Unauthorized Access</h2>
      <p>You do not have permission to view this page.</p>
    </div>
  )
}

export default Unauthorized
